import React, { useContext, useState, FormEvent } from "react";
import { observer } from "mobx-react-lite";
import { IProjectLog } from "../../../app/models/projectlog";
import TransmissionStore from "../../../app/stores/transmissionStore";
import {
    Tab,
    Grid,
    Button,
    Table,
    Label,
    Form,
    Dimmer,
  } from "semantic-ui-react";
const LogTab = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmission,
    deleteProjectLog,
    createProjectLog,
    loadProjectLogs,
    projectlogsByDate,
    submitting,
  } = transmissionStore;

  const [projectlog, setProjectLog] = useState<IProjectLog>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    notes: "",
  });


  const [addMode, setAddMode] = useState(false);
  const [active, setDimmer] = useState({
    rowid: "",
    status: false,
  });


  const handleSubmit = () => {
    !addMode &&
      projectlog.notes &&
      createProjectLog(projectlog).then(() =>
        loadProjectLogs(projectlog.projectId)
      );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectLog({ ...projectlog, [name]: value });
  };
  return <Tab.Pane>
      <Grid>
        <Grid.Column width={16}>
          <Form onSubmit={handleSubmit}>
            <Button
              loading={submitting}
              floated="right"
              positive
              type="submit"
              content={addMode ? "Submit" : "Add"}
              onClick={() => setAddMode(!addMode)}
            />
            {addMode && (
              <Form.TextArea
                label="Notes"
                onChange={handleInputChange}
                name="notes"
                rows={2}
                placeholder="Notes"
                value={projectlog.notes}
              />
            )}
          </Form>
        </Grid.Column>
      </Grid>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={3}>Date</Table.HeaderCell>
            <Table.HeaderCell>Notes</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {projectlogsByDate.map((projectlog) => (
            <Table.Row key={projectlog.id}>
              <Dimmer.Dimmable
                dimmed
                onMouseEnter={() =>
                  setDimmer({ ["rowid"]: projectlog.id, ["status"]: true })
                }
                onMouseLeave={() =>
                  setDimmer({ ["rowid"]: projectlog.id, ["status"]: false })
                }
              >
                <Table.Cell>
                  <Label>{projectlog.createdAt.substr(0, 19)}</Label>
                </Table.Cell>
                <Dimmer
                  active={active.rowid === projectlog.id && active.status}
                >
                  <Button
                    name={projectlog.id}
                    size="mini"
                    // loading={target === projectlog.id && submitting}
                    onClick={(e) => deleteProjectLog(e, projectlog.id)}
                    content="Delete"
                    color="red"
                  />
                </Dimmer>
              </Dimmer.Dimmable>
              <Table.Cell>{projectlog.notes}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Tab.Pane>;
};

export default observer(LogTab);
